import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import utils from '../../helpers/GlobalVariables';
import { deleteNodeImage } from '../../stores/actions/installerActions';
import Loading from '../Loading/Loading';

interface RemoveNodeImageConfirmationProps {
	image: any;
	hideRemoveNodeImageConfirmation: () => void;
	deleteNodeImageSuccess: boolean;
	deleteNodeImageFailed: boolean;
	deleteNodeImage: (nodeId: number) => void;
}

const closeButtonStyle = {
	border: '1px solid #00acc1',
};

const RemoveNodeImageConfirmationCard = ({
	image,
	hideRemoveNodeImageConfirmation,
	deleteNodeImageSuccess,
	deleteNodeImageFailed,
	deleteNodeImage,
}: RemoveNodeImageConfirmationProps) => {
	const dispatch = useDispatch();

	const [isLoaderRender, setIsLoaderRender] = useState(false);

	useEffect(() => {
		dispatch({ type: 'RESET_NODE_IMAGE_FLAGS'})
		}, [dispatch]);
		
	useEffect(() => {
		if (deleteNodeImageSuccess) {
			hideRemoveNodeImageConfirmation();
		}
	}, [deleteNodeImageSuccess]);
		
	const closeButtonHover = (e) => {
		const button = e.target;
		button.style.backgroundColor = 'rgba(0, 172, 193, 0.1)';
	};

	const closeButtonLeave = (e) => {
		const button = e.target;
		button.style.backgroundColor = '#ffffff';
	};

	const handleDeleteNode = () => {
		deleteNodeImage(image.id);
	};

	const handleRemoveButtonClicked = () => {
		setIsLoaderRender(true);
		handleDeleteNode();
	};

	return (
		<>
			<div>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							data-testid='cancelButton'
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={hideRemoveNodeImageConfirmation}
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>
				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='remove-node-card'>
					<CardHeader color='info' icon>
						<h3 style={utils.sweetAlertHeaderStyle} className='remove-node-header'>
							<img
								src={`data:${image.imageFileType};base64,${image.imageData}`}
								alt=""
								style={{
									width: "100%",
									height: 200,
									objectFit: "cover",
									borderRadius: 8,
								}}
							/>
						</h3>
					</CardHeader>
					<CardBody>
						<GridContainer>
							<GridItem xs={12}>
								<h5>This operation is irreversible. Are you sure to delete this image?</h5>
							</GridItem>
							<GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
								<div style={{ display: 'flex', justifyContent: 'space-around', width: '100%' }}>
									<Button
										className='deleteNodeCloseButton'
										simple
										color='info'
										style={closeButtonStyle}
										onClick={hideRemoveNodeImageConfirmation}
										onMouseEnter={(e) => closeButtonHover(e)}
										onMouseLeave={(e) => closeButtonLeave(e)}
									>
										cancel
									</Button>
									<Button
										style={{ backgroundColor: isLoaderRender ? '#ccc' : '#f44336' }}
										onClick={handleRemoveButtonClicked}
										disabled={isLoaderRender || deleteNodeImageSuccess || deleteNodeImageFailed}
									>
										{isLoaderRender ? <Loading transform={1} height={17} width={48} color='darkGray' /> : 'remove'}
									</Button>
								</div>
							</GridItem>
						</GridContainer>
					</CardBody>
				</Card>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		deleteNodeImageSuccess: state.dashboard.deleteNodeImageSuccess,
		deleteNodeImageFailed: state.dashboard.deleteNodeImageFailed,
	};
};

const actions = {
	deleteNodeImage,
};

export default connect(mapStateToProps, actions)(RemoveNodeImageConfirmationCard);
